import { Exception } from 'src/app/core/logic/exception';

export class CustomTrackerNotFoundException extends Exception<never> {
  constructor() {
    super('Custom tracker non trouvé');
  }
}
